<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Business use percentage - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="percentage">Percentage</label>
                <input type="text" 
                class="form-control" 
                id="percentage" 
                placeholder="Percentage"
                v-model="percentage">
                <div class="invalid-feedback" v-if="errors.percentage">{{ errors.percentage[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as businessUsePercentageService from '../../services/businessUsePercentage.service';
    export default {
        name:"ModalBusinessUsePercentageNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                percentage:''
            }
        },
        methods:{
            ...mapActions(['fetchBusinessUsePercentageAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                let formData = new FormData();
                formData.append('percentage',this.percentage);
            try{
                const response = await businessUsePercentageService.add(formData);
                this.hideModal();
                this.fetchBusinessUsePercentageAll();
                messageService.fnSweetAlertSuccessToast('Business use percentage - new', 'added successfully');

                this.percentage = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Business use percentage - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Business use percentage - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>